import Enumerable from "linq";
import { Command, HttpMethod } from "~/extensions/api";
import { myPageStore } from "~/store/MyPageStore";
export class TaikyoSave extends Command {
    constructor(model) {
        super(HttpMethod.Post, "taikyonotification/save/insert");
        this.bulkTaikyoNo = model.bulkTaikyoNo;
        this.tantoshaName = model.tantoshaName;
        this.tantoshaTel = model.tantoshaTel;
        this.tantoshaEmail = model.tantoshaEmail;
        if (!myPageStore.personal.isMma) {
            this.isKouzaNotRequired = model.isKouzaNotRequired;
        }
        this.henkinBankCd = model.henkinBankCd;
        this.henkinBansCd = model.henkinBansCd;
        this.henkinBankName = model.henkinBankName;
        this.henkinBansName = model.henkinBansName;
        this.henkinKouzaSb = model.henkinKouzaSb;
        this.henkinKouzaNo = Number(model.henkinKouzaNo);
        this.henkinKouzaKana = model.henkinKouzaKana;
        this.henkinKouzaName = model.henkinKouzaName;
        this.taikyoSaveList = Enumerable.from(model.taikyoList).select(x => new TaikyoNotificationSave(x)).toArray();
    }
    /** 一括退去申請No. */
    bulkTaikyoNo = "";
    /** 担当者名 */
    tantoshaName = "";
    /** 担当者電話番号 */
    tantoshaTel = "";
    /** 担当者メールアドレス */
    tantoshaEmail = "";
    /** 返金先口座入力不要フラグ */
    isKouzaNotRequired = null;
    /** 返金銀行コード */
    henkinBankCd = null;
    /** 返金支店コード */
    henkinBansCd = null;
    /** 返金銀行名 */
    henkinBankName = "";
    /** 返金支店名 */
    henkinBansName = "";
    /** 返金口座種別 */
    henkinKouzaSb = -1;
    /** 返金口座番号 */
    henkinKouzaNo = -1;
    /** 返金口座名称 */
    henkinKouzaKana = "";
    /** 返金口座名カナ */
    henkinKouzaName = "";
    /** 退去情報 */
    taikyoSaveList = [];
}
class TaikyoNotificationSave {
    constructor(model = null) {
        if (model === null) {
            return;
        }
        this.nyukyokeiyakuNo = model.nyukyokeiyakuNo;
        this.taikyoNo = model.taikyoNo;
        this.taikyoYmd = model.taikyoYmd?.toString() ?? "";
        this.taikyoRiyuKb = model.taikyoRiyuKb;
        this.taikyoRiyu = model.taikyoRiyu;
        this.sonotaKeiyaku = model.sonotaKeiyaku;
        this.keyReturnNameKb = model.keyReturnNameKb;
        this.keyReturnYmd = String(model.keyReturnYmd);
        this.keyReturnYoteiNum = model.numberOfReturnKeys;
        this.taikyoTachiaiKb = model.taikyoTachiaiKb;
        this.taikyoTachiaiName = model.taikyoTachiaiName;
        this.renrakuKb = model.renrakuKb;
        this.renrakuName = model.renrakuName;
        this.renrakuRelationship = model.renrakuRelationship;
        this.renrakuTel = model.tel;
        this.renrakuEmail = model.email;
        this.keyReturnAdrKb = model.keyReturnAdrKb;
        this.soufuName = model.soufuName;
        this.renrakuPostCode = model.postCode;
        this.renrakuAdr1 = model.adr1;
        this.renrakuAdr2 = model.adr2;
        this.renrakuAdr3 = model.adr3;
        this.renrakuSonota = model.soufuSonota;
        this.fileList = model.fileList;
        this.IgnoreSaveFlg = model.isDeleted;
    }
    /** 入居契約No. */
    nyukyokeiyakuNo = -1;
    /** オリジナル入居契約No. (退去申請No.)*/
    taikyoNo = -1;
    /** 退去予定日 */
    taikyoYmd = "";
    /** 退去理由区分 */
    taikyoRiyuKb = null;
    /** 退去理由 */
    taikyoRiyu = "";
    /** その他ご契約事項 */
    sonotaKeiyaku = "";
    /** 鍵渡名称区分 */
    keyReturnNameKb = null;
    /** 鍵渡予定日 */
    keyReturnYmd = "";
    /** 鍵返却予定本数 */
    keyReturnYoteiNum = null;
    /** 退去立会者区分 */
    taikyoTachiaiKb = null;
    /** 退去立会者名 */
    taikyoTachiaiName = "";
    /** 連絡先区分 */
    renrakuKb = null;
    /** 連絡先名 */
    renrakuName = "";
    /** 入居者との関係性 */
    renrakuRelationship = "";
    /** 連絡先電話番号 */
    renrakuTel = "";
    /** 連絡先メールアドレス */
    renrakuEmail = "";
    /** 鍵封筒送付先区分 */
    keyReturnAdrKb = null;
    /** 宛先 */
    soufuName = "";
    /** 連絡先郵便番号 */
    renrakuPostCode = "";
    /** 連絡先住所1（県市区町村） */
    renrakuAdr1 = "";
    /** 連絡先住所2（番地） */
    renrakuAdr2 = "";
    /** 連絡先住所3（建物名号室） */
    renrakuAdr3 = "";
    /** 連絡先その他 */
    renrakuSonota = "";
    /** 添付ファイルリスト */
    fileList = [];
    /** 保存対象外フラグ */
    IgnoreSaveFlg = false;
}
